export function customBtnBack($backBtn, $form) {
    if (!$backBtn || $backBtn.length === 0 || !$form || $form.length === 0) {
        return;
    }

    const $newBackBtn = jQuery('<button>', {
        class: 'custom-back-button',
        type: 'button',
    });

    // Copiamos el texto del botón original (por traducciones)
    $newBackBtn.text($backBtn.text());
    $newBackBtn.prepend('<i class="fa-solid fa-arrow-left"></i>');

    $form.prepend($newBackBtn);

    $newBackBtn.on('click', function (e) {
        e.preventDefault();
        $backBtn.trigger('click');
        $backBtn.trigger('mousedown');
    });

    $backBtn.css('display', 'none');
}
